import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2da10f64")

_pushScopeId("data-v-2da10f64")
const _hoisted_1 = {
  key: 0,
  class: "culture-module-container"
}
const _hoisted_2 = { class: "culture-module-title-container" }
const _hoisted_3 = { class: "culture-module-title" }
const _hoisted_4 = { class: "culture-module-sub-title" }
const _hoisted_5 = {
  key: 0,
  class: "culture-module-stream-container"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "stream-background" }, null, -1)
const _hoisted_7 = { class: "stream-item" }
const _hoisted_8 = { class: "stream-item-title" }
const _hoisted_9 = { class: "stream-item-sub-title" }
const _hoisted_10 = {
  key: 1,
  class: "culture-module-tab-container"
}
const _hoisted_11 = { class: "tab-item-container" }
const _hoisted_12 = { class: "tab-item-title" }
const _hoisted_13 = { class: "tab-item-intro" }
const _hoisted_14 = {
  key: 2,
  class: "culture-module-text-container"
}
const _hoisted_15 = { class: "text-item-intro" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "text-item-intro-block" }, null, -1)
const _hoisted_17 = {
  key: 3,
  class: "culture-module-video-container"
}
const _hoisted_18 = {
  key: 4,
  class: "culture-module-card-container"
}
const _hoisted_19 = { class: "card-item-titles" }
const _hoisted_20 = { class: "card-item-intro" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.modules)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "culture-module-item",
            key: index
          }, [
            _createVNode("div", {
              class: 'culture-module-number-container number-' + (index + 1)
            }, null, 2),
            _createVNode("div", _hoisted_2, [
              _createVNode("span", _hoisted_3, _toDisplayString(item.title), 1),
              _createVNode("span", _hoisted_4, _toDisplayString(item.subtitle), 1)
            ]),
            (item.type == 'stream')
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.moduleList, (moduleItem, moduleIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "stream-item-wrapper",
                      key: moduleIndex
                    }, [
                      _hoisted_6,
                      _createVNode("div", _hoisted_7, [
                        _createVNode("img", {
                          class: "stream-item-img",
                          src: moduleItem.img
                        }, null, 8, ["src"]),
                        _createVNode("span", _hoisted_8, _toDisplayString(moduleItem.title), 1),
                        _createVNode("span", _hoisted_9, _toDisplayString(moduleItem.subtitle), 1)
                      ])
                    ]))
                  }), 128))
                ]))
              : (item.type == 'tab')
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.moduleList, (moduleItem, moduleIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "tab-item-wrapper",
                        key: moduleIndex
                      }, [
                        _createVNode("div", _hoisted_11, [
                          _createVNode("div", _hoisted_12, [
                            _createVNode("img", {
                              class: "tab-item-title-icon",
                              src: moduleItem.titleIcon
                            }, null, 8, ["src"]),
                            _createVNode("span", null, _toDisplayString(moduleItem.title), 1)
                          ]),
                          _createVNode("div", _hoisted_13, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(moduleItem.intro, (m, n) => {
                              return (_openBlock(), _createBlock("p", { key: n }, _toDisplayString(m), 1))
                            }), 128))
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : (item.type == 'text')
                  ? (_openBlock(), _createBlock("div", _hoisted_14, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.moduleList, (moduleItem, moduleIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "text-item-wrapper",
                          key: moduleIndex
                        }, [
                          _createVNode("div", {
                            class: 
              'text-item-background background-type-' +
              moduleItem.backgroundType
            
                          }, [
                            _createVNode("div", _hoisted_15, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(moduleItem.intro, (m, n) => {
                                return (_openBlock(), _createBlock("p", { key: n }, _toDisplayString(m), 1))
                              }), 128))
                            ]),
                            _hoisted_16
                          ], 2)
                        ]))
                      }), 128))
                    ]))
                  : (item.type == 'video')
                    ? (_openBlock(), _createBlock("div", _hoisted_17, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.moduleList, (moduleItem, moduleIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "video-item-wrapper",
                            key: moduleIndex
                          }, [
                            _createVNode("video", {
                              src: moduleItem.video,
                              controls: "controls",
                              preload: "auto",
                              "x5-playsinline": "true",
                              playsinline: "true",
                              "webkit-playsinline": "true"
                            }, null, 8, ["src"])
                          ]))
                        }), 128))
                      ]))
                    : (item.type == 'card')
                      ? (_openBlock(), _createBlock("div", _hoisted_18, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.moduleList, (moduleItem, moduleIndex) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "card-item-wrapper",
                              key: moduleIndex
                            }, [
                              _createVNode("div", _hoisted_19, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(moduleItem.titles, (i, k) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "card-item-titles-container",
                                    key: k
                                  }, [
                                    _createVNode("div", {
                                      class: 'card-item-titles-icon ' + 'icon-' + (k + 1)
                                    }, null, 2),
                                    _createVNode("span", null, _toDisplayString(i), 1)
                                  ]))
                                }), 128))
                              ]),
                              _createVNode("div", _hoisted_20, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(moduleItem.intro, (m, n) => {
                                  return (_openBlock(), _createBlock("p", { key: n }, _toDisplayString(m), 1))
                                }), 128))
                              ]),
                              _createVNode("video", {
                                src: moduleItem.video,
                                poster: moduleItem.poster,
                                controls: "controls",
                                preload: "auto",
                                "x5-playsinline": "true",
                                playsinline: "true",
                                "webkit-playsinline": "true",
                                onPlay: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleVideoPlay && _ctx.handleVideoPlay(...args)))
                              }, null, 40, ["src", "poster"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
})